import React from 'react';
import cs from 'classnames';
import get from 'lodash/get';
import format from 'date-fns/format';
import {connect} from 'react-redux';

import accounting from '~/misc/accounting';
import weightFormat from '~/misc/weight';
import {getDistance} from '~/misc/geo';
import * as equipment from '~/misc/equipment';
import PremiumIcon from '../PremiumIcon';
import AgeLabel from '~/components/AgeLabel';
import config from '~/config';
import PriceWithType from '~/components/common/PriceWithType';
import mapDispatch from '~/misc/mapDispatch';
import * as modes from '~/modules/modal/modes';
import {modalChange} from '~/modules/modal/actions';
import TableCheckbox from '~/components/common/TableCheckbox';
import {makeUrlQueryString} from "~/misc/formatUrlquery";
import { getType } from "~/misc/loadTypes"
import UnlockBtn from '~/components/common/UnlockEst'
import css from './index.css';

const shortLocationName = (props, field) => {
  const city = props[`${field}_city`];
  if (!city) {
    return props[field] && props[field].toLowerCase();
  }
  return city.toLowerCase();
};

const NColumn = (props) => (<div
  className={cs(css.nColumn, props.className)}
  title={props.title}
  data-qa={props['data-qa']}
>
  {props.children}
</div>);

const Header = (props) => (
  <NColumn
    className={cs(css.nColumnHeader, props.className)}
    title={props.title}
    data-qa={props['data-qa']}
  >
    {props.children}
  </NColumn>
);
export const RowsHeader = connect(() => ({
}), mapDispatch({
}))(({
  // isSimilar,
  checkbox,
  checkedAll,
  checkedAllClick,
}) => (
  <div className={cs(css.itemShape, css.itemsHeader)}>
    {
      checkbox ? (
        <Header  
        className={css.columnCheck}
        title='Check'>
          <TableCheckbox checked={checkedAll} click={checkedAllClick} className={css.checkBox}/>
        </Header>
      ) : (
        <Header  title='Check'>
        </Header>
      )
    }
    <Header className={css.columnAge} title='Age'>Age</Header>

    <Header className={css.columnPickup} title='Pickup date'>Pickup</Header>

    <Header
      className={css.columnDho}
      title='Deadhead from your location to Pickup location'
    >Dh-O</Header>
    <Header className={css.columnOrigin} title='Pickup location name'>Origin</Header>
    <Header className={css.columnOState} title='Pickup State' />
    <Header
      className={css.columnDhd}
      title='Deadhead from dropoff location to your destination'
    >Dh-D</Header>
    <Header className={css.columnDestination}  title='Drop-off destination name'>Destination</Header>
    <Header className={css.columnDState} title='Drop-off destination state' />
    <Header className={css.columnTrip} title='Trip length'>Trip</Header>

    <Header
      className={css.columnLenght}
      title='Truck length required'
    >Length</Header>
    <Header className={css.columnWeight} title='Load weight'>Weight</Header>
    <Header className={css.columnSize} title='Load Size'>Size</Header>
    <Header className={css.columnTruck} title='Truck equipment'>Truck</Header>
    <Header className={css.columnTpIcon} title='TPIcon'></Header>
    <Header className={css.columnBroker}>Broker</Header>
    <Header className={css.columnDTP}>DTP</Header>
    <Header className={css.columnCS}>CS</Header>
    <Header className={css.columnPrice}>Price</Header>
  </div>
));

export const LoadRow = connect(({
  loads: {showSignLoginBtn, currentId},
  bids,
  user,
  loadsSearch,
  now: {minute},
  introduction,
  account: {accountLevel, free},
  window: {globalParams},
}, {load}) => ({
  userIsLoggedIn: user.isLoggedIn,
  deleted: Boolean(load.deleted || (loadsSearch.deletedIndex && loadsSearch.deletedIndex[load.id])),
  properAge: Math.max(minute - load.created_at, 0),
  bidValue: get(bids, ['index', load.id, 'value']),
  showIntroduction: !introduction.loadOpened && config.loadIntroduction,
  accountLevel: accountLevel,
  free: free,
  showSignLoginBtn: showSignLoginBtn,
  currentId: currentId,
  user,
  globalParams,
}), mapDispatch({
  login: () => modalChange(modes.LOGIN, 'loadRow'),
  signup: () => modalChange(modes.SIGNUP, 'loadRow'),
  showUpgradeModal :(_,{source,type}) => modalChange('pop', {
    source: source,
    type: type,
  }),
}))(({
  dataQa, load: i, position, isFresh, userIsLoggedIn, query, onClick, viewed, isSimilar, isMain, active, deleted,
  properAge, bidValue, isLink, compactView, showIntroduction, checkbox, checkClick,
  accountLevel, free, globalParams, unlockFn, isMember,
  showUpgradeModal
}) => {
  const isPremium = i.featured;
  const isLoggedIn = userIsLoggedIn;
  const judgeMember = () => {
    if (parseInt(accountLevel) > parseInt(free)) {
      return true;
    }
    return false;
  };
  const from = {
    lat: get(query, 'from_lat'),
    lng: get(query, 'from_lng'),
  };
  const dho = getDistance(from, i.from_location);

  const to = {
    lat: get(query, 'to_lat'),
    lng: get(query, 'to_lng'),
  };
  const dhd = getDistance(to, i.to_location);

  const equipmentText = i.equipment.map(eq => get(equipment.humanLowerCaseToId, eq, 'Any')).join(' ');
  const equipmentTitle = i.equipment.map(eq => get(equipment.humanLowerCaseToFull, eq, 'Any')).join(', ');

  const fullSize = i.load_size === 'full';
  const C = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    checkClick(i.id);
  };
  const renderContent = () => {
    // if (judgeMember()) {
    return (
      <span className={css.columnBroker}>
        {i.company ? i.company : '—'}
      </span>
    );
    // }
    // return (
    //   < NColumn
    //     className={cs('qa-search-results-broker', css.nColumnBroker)}
    //     title = {'—'}
    //   >
    //     {'—'}
    //   </NColumn>
    // );
  };

  const renderScore = (par,type) => {
    // score is DTP col days is CS col
    const { days, score } = par;
    const show = type === 'score' ? score : days;
    const event = type === 'score' ? 'dtp_list' : 'cs_list';
    return parseInt(accountLevel) >= 2 ? (
      <span>{show || '--'}</span>
    ) : (
      <UnlockBtn
        isMobileHide
        onClick={() =>
          showUpgradeModal({
            source: event,
            type: 'pop_upgrade_to_essential_standard',
          })
        }
      />
    );
  };
  return (
    <a
      className={cs(css.itemShape, css.item, {
        [css.isFresh]: isFresh && !deleted && !viewed,
        [css.removedLoad]: deleted,
        [css.rowSelected]: active,
        [css.rowViewed]: viewed,
        [css.compactView]: compactView,
        [css.checkedBg]: i.checked && checkbox,
        'qa-isMain': isMain,
        'qa-isSimilar': isSimilar,
        'qa-isPremium': isPremium,
        'qa-isRemoved': deleted,
        'qa-isAdded': isFresh,
        'qa-isFresh': isFresh && !deleted && !viewed,
        'qa-isViewed': viewed,
        [css.selectable]: onClick || isLink,
        [css.attention]: showIntroduction && position === 0,
      })}
      onClick={onClick}
      data-id={i.id}
      data-position={position + 1}
      data-qa={dataQa}
      data-premium={isPremium}
      data-accountLevel={accountLevel}
      target='_blank'
      href={(onClick || isLink) && `/loads/${i.id}?${makeUrlQueryString(globalParams)}`}>
      {checkbox ? (
        <TableCheckbox checked={i.checked} click={C} className={(css.checkBox, css.columnCheck)} />
      ) : (
        <div className={css.columnCheck}></div>
      )}
      <AgeLabel
        className={cs(css.ageLabel, css.columnAge)}
        properAge={properAge}
        deleted={deleted}
        viewed={viewed}
        bookingLoad={i.book_now}
      />
      {config.anyDateMark && i.isFlexible ? (
        <span className={cs(css.anyDate, css.columnPickup)}>any day</span>
      ) : (
        <span className={css.columnPickup}>{format(i.from_date_local, 'MMM D')}</span>
      )}
      <span className={css.columnDho}>{dho ? `${dho} mi` : '—'}</span>
      <span className={css.columnOrigin}>{shortLocationName(i, 'from')}</span>
      <span className={css.columnOState}>{i.from_state}</span>
      <span className={css.columnDhd}>{dhd ? `${dhd} mi` : '—'}</span>
      <span className={css.columnDestination}>{shortLocationName(i, 'to')}</span>
      <span className={css.columnDState}>{i.to_state}</span>
      <span className={css.columnTrip}>
        {i.distance ? `${accounting.formatNumber(i.distance)} mi` : '—'}
      </span>
      <span className={css.columnLenght}>{i.length ? `${i.length}ft` : '—'}</span>
      <span className={css.columnWeight}>{weightFormat(i.weight)}</span>
      <span
        title={`Load Size: ${i.load_size}`}
        className={cs('qa-search-results-size', css.sizeIcon, css.columnSize, {
          [css.sizeFull]: fullSize,
          [css.sizePartial]: !fullSize,
          'qa-search-results-size-full': fullSize,
          'qa-search-results-size-partial': !fullSize,
        })}
      />
      <span className={css.columnTruck}>{equipmentText}</span>

      {(isPremium && (
        <span className={css.columnTpIcon}>
          <PremiumIcon />
        </span>
      )) || <span></span>}
      {isLoggedIn ? (
        renderContent()
      ) : (
        <UnlockBtn
          isMobileHide
          onClick={() =>
            showUpgradeModal({
              source: 'list_broker',
              type: 'pop_upgrade_to_essential_standard',
            })
          }
        />
      )}
      <span className={css.columnDTP}>{renderScore(i.score, 'score')}</span>
      <span className={css.columnCS}>{renderScore(i.score, 'day')}</span>
      <span className={css.columnPrice}>
        {i.target_price ? (
          <PriceWithType
            price={i.target_price}
            type={getType({
              isBid: i.biddable,
              isBooking: i.book_now,
            })}
          />
        ) : isMember && isLoggedIn ? (
          i.est_price ? (
            <PriceWithType
              price={i.est_price}
              type={getType({
                isBid: i.biddable,
                isBooking: i.book_now,
              })}
            />
          ) : (
            '--'
          )
        ) : (
          <UnlockBtn isMobileHide onClick={unlockFn} />
        )}
      </span>
    </a>
  );
});



// WEBPACK FOOTER //
// ./src/components/search/results/LoadRow/index.js